var AppDispatcher = require('../core/AppDispatcher.jsx');
var ActionTypes = require('../constants/IDVerificationConstants.js').ActionTypes;

module.exports = {
    receiveSendNetCodeResult: function (result) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.RECEIVE_SEND_NETCODE_RESULT,
            result: result
        });
    },
    receiveResendNetCodeResult: function (result) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.RECEIVE_RESEND_NETCODE_RESULT,
            result: result
        });
    },
    
    receiveVerifyNetCodeResult: function (result) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.RECEIVE_VERIFY_NETCODE_RESULT,
            result: result
        });
    },
    receiveVerifyMultipleNetCodeResult: function (result) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.RECEIVE_VERIFY_MUTIPLE_NETCODE_RESULTS,
            result: result
        });
    },
    receiveClientIpAddress: function(result) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.RECEIVE_CLIENT_IP_ADDRESS,
            result: result
        });
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./actions/DigitalConsentApiCallBackActions.js